import React from 'react';
import { Box, Typography, Button, Chip } from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import StopCircleIcon from '@mui/icons-material/StopCircle';

const ImpersonationBanner = ({ impersonatedUser, realUser, onStop, loading }) => {
  if (!impersonatedUser) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: 'linear-gradient(90deg, #e65100 0%, #ff8f00 100%)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        py: 0.75,
        px: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        minHeight: 44,
      }}
    >
      <SwapHorizIcon fontSize="small" />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Viewing as
      </Typography>
      <Chip
        label={`${impersonatedUser.username || impersonatedUser.email} (${impersonatedUser.role})`}
        size="small"
        sx={{
          backgroundColor: 'rgba(255,255,255,0.25)',
          color: '#fff',
          fontWeight: 600,
        }}
      />
      {realUser && (
        <Typography variant="body2" sx={{ opacity: 0.85 }}>
          &mdash; logged in as {realUser.username || realUser.email}
        </Typography>
      )}
      <Button
        variant="contained"
        size="small"
        startIcon={<StopCircleIcon />}
        onClick={onStop}
        disabled={loading}
        sx={{
          ml: 2,
          backgroundColor: 'rgba(255,255,255,0.2)',
          color: '#fff',
          fontWeight: 600,
          '&:hover': { backgroundColor: 'rgba(255,255,255,0.35)' },
          textTransform: 'none',
        }}
      >
        Stop Impersonating
      </Button>
    </Box>
  );
};

export default ImpersonationBanner;
